module.exports = __webpack_public_path__ + "img/ai_classroom_text.8f6e32c6.png";